import { useEffect, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import {
  getDataAplicacaoFormularioGlobal,
  getLookupId,
  SITUACAO_APLICACAO_FORMULARIO_GLOBAL,
} from 'src/paginas/avaliacao-desempenho/PesquisaClima/utils';

export default function useDashboardAplicacoes(
  entidadeId,
  { enabled = true, refreshToken = 0 } = {}
) {
  const [aplicacoes, setAplicacoes] = useState([]);
  const [entidadeCarregada, setEntidadeCarregada] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !entidadeId) {
      setAplicacoes([]);
      return undefined;
    }

    let ativo = true;
    const carregarAplicacoes = async () => {
      setIsLoading(true);
      try {
        const response = await http.get(
          '/FormularioGlobalRespostas/ObterAplicacoes',
          { params: { entidadeId } }
        );
        const dados = response.data?.model || response.data || [];
        const lista = Array.isArray(dados)
          ? dados
          : dados.aplicacoes || dados.usos || [];

        if (ativo) {
          setEntidadeCarregada(entidadeId);
          setAplicacoes(
            lista
              .filter(
                (uso) =>
                  uso?.formularioUsoId &&
                  getLookupId(uso.situacao) !==
                    SITUACAO_APLICACAO_FORMULARIO_GLOBAL.PREVISTA
              )
              .sort((a, b) => {
                const dataA =
                  getDataAplicacaoFormularioGlobal(a.dataInicio)?.getTime() ||
                  0;
                const dataB =
                  getDataAplicacaoFormularioGlobal(b.dataInicio)?.getTime() ||
                  0;
                return dataB - dataA || b.formularioUsoId - a.formularioUsoId;
              })
          );
        }
      } catch (err) {
        if (ativo) {
          setEntidadeCarregada(null);
          setAplicacoes([]);
          errorHandler(err);
        }
      } finally {
        if (ativo) setIsLoading(false);
      }
    };

    carregarAplicacoes();
    return () => {
      ativo = false;
    };
  }, [enabled, entidadeId, refreshToken]);

  return {
    aplicacoes: entidadeCarregada === entidadeId ? aplicacoes : [],
    isLoading,
  };
}
